import { render, staticRenderFns } from "./NonCompliantDeals.vue?vue&type=template&id=d4220cc0"
import script from "./NonCompliantDeals.vue?vue&type=script&lang=js"
export * from "./NonCompliantDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports